import { useContext } from 'react';
import { IndexContext } from "./IndexContext.js";
import { invariant } from "./invariant.js";
export function useIndexContext() {
  var context = useContext(IndexContext);
  invariant(context !== null, 'The <Index> component must be used within <InstantSearch>.');
  return context;
}